import { useEffect } from 'react';

import type { UseClientDataEffectsProps } from '@app/components/EditClient/types';

export const useClientDataEffects = ({
  initForm,
  handleConfirm,
  isOpen,
  hasChanges,
  isInitialized,
  checkUnsavedData,
}: UseClientDataEffectsProps) => {
  useEffect(() => {
    initForm();
  }, [initForm]);

  useEffect(() => {
    if (isOpen) {
      handleConfirm();
    }
  }, [handleConfirm, isOpen]);

  useEffect(() => {
    checkUnsavedData();
  }, [checkUnsavedData]);

  useEffect(() => {
    if (!isInitialized || !hasChanges) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isInitialized, hasChanges]);
};
